module.exports = __webpack_public_path__ + "static/media/Button_Video.40af1212.png";